import { Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { ScenarioExt } from '@/classes/scenario/ScenarioExt';
import { ScenarioRenFrPVExt } from '@/classes/scenario/ren-fr/pv/ScenarioRenFrPVExt';

const getDefaultFields = () => new ScenarioRenFrPVExt();

export const buildRenFrPVModule = () => {

  @Module({
    namespaced: true
  })
  class RenFrPVModule extends VuexModule {

    private presets: Record<string, string | number> | null = null;

    @Mutation
    private setPresets(payload: Record<string, string | number> | null) {
      this.presets = payload;
    }

    get getConfig(): ScenarioExt {
      return new ScenarioExt(this.context.rootGetters['scenario/getFields']);
    }

    get getFields(): ScenarioRenFrPVExt {
      return this.getConfig.ren_fr_pv ? new ScenarioRenFrPVExt(this.getConfig.ren_fr_pv) : getDefaultFields();
    }

    get getPresets(): Record<string, string | number> | null {
      return this.presets;
    }
  }

  return RenFrPVModule;
};
